<template>
<div class="bb-px2pt6 pb3 flex flex-wrap items-center border-box bb-w100p">
  <div class="col-12 lg-hide xl-hide mt2"></div>
    <div class="col-4">
      <span v-show="this.$router.history.current.meta.showBackBtn">
        <div @click="$router.go(-1)"
          class="bb-fc1 bb-fc2-hover bb-pointer bb-transition2
          bb-ff2 text-decoration-none">
          <span class="bb-mln0pt6">
            <i class="material-icons align-middle bb-fs2pt17">&#xE5CB;</i>
          </span>
          <span class="xs-hide sm-hide md-hide">
            <span class="align-middle bb-ff2 bb-fs1pt13">
              Back
              <span class="bb-fs0">{{ $route.name }}</span>
            </span>
          </span>
       </div>
      </span>
    </div>

    <div class="col-4 flex justify-center">
      <router-link
        to="/"
      >
        <img
          src="../assets/icons/bigbang-logo02.svg"
          class="
            xs-hide
            sm-hide
            md-hide
            bb-h4pt5
            bb-mt1pt2
          "
        >
        <img
          src="../assets/icons/bigbang-icon.svg"
          class="
            bb-w4
            bb-sm-w5
            pt1
            lg-hide xl-hide
        ">
      </router-link>
    </div>

    <div class="col-4 flex justify-end">
      <div
        v-if="userLoggedIn"
        @click="this.logout"
        class="
          bb-fc1
          bb-fc2-hover
          bb-pointer
          bb-transition2
          bb-ff2
        "
      >
        {{ $lang.messages.logout }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header.vue